export const DropMagicFrameAnimation = async (
  originalEl: HTMLElement,
  dropTarget: HTMLElement,
  mousePosition?: { x: number; y: number }
) => {

    const clone = originalEl.cloneNode(true) as HTMLElement;
    const originalRect = originalEl.getBoundingClientRect();

    let startX: number;
    let startY: number;

    if (mousePosition) {
        startX = mousePosition.x - (originalRect.width / 2);
        startY = mousePosition.y - (originalRect.height / 2);
    } else {

        const targetRect = dropTarget.getBoundingClientRect();

        startX = targetRect.left;
        startY = targetRect.top;
    }

    copyComputedStyles(originalEl, clone);

    Object.assign(clone.style, {
        position: 'fixed',
        top: `${startY}px`,
        left: `${startX}px`,
        transition: 'all 0.6s ease',
        zIndex: 999999,
        pointerEvents: 'none',
        transform: 'scale(2.5)',
        opacity: '1'
    });

    document.body.appendChild(clone);

    requestAnimationFrame(() => {
        Object.assign(clone.style, {
            top: `${startY}px`,
            left: `${startX}px`,
            transform: 'scale(1)',
            opacity: '0'
        });
    });

    setTimeout(() => {
        clone.remove();
    }, 600);
};

const copyComputedStyles = (originalElement: Element, cloneElement: HTMLElement) => {
    const computedStyle = window.getComputedStyle(originalElement);

    const stylesToCopy = [
        'background', 'color', 'font-size', 'font-family', 'font-weight',
        'line-height', 'text-align', 'padding', 'margin', 'border',
        'border-radius', 'border-top-left-radius', 'border-top-right-radius',
        'border-bottom-left-radius', 'border-bottom-right-radius',
        'box-shadow', 'opacity', 'transform', 'width', 'height', 'position',
        'filter', 'overflow', 'background-image', 'mix-blend-mode'
    ];

    stylesToCopy.forEach(property => {
        const value = computedStyle.getPropertyValue(property);
        cloneElement.style.setProperty(property, value);
    });

    const originalChildren = originalElement.children;
    const cloneChildren = cloneElement.children;

    for (let i = 0; i < originalChildren.length && i < cloneChildren.length; i++) {
        copyComputedStyles(originalChildren[i], cloneChildren[i] as HTMLElement);
    }
};